import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OpenAPIService,
  AnyValueModelString,
  PlatformType,
  LatLonModel,
  TrackingModel
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class OpenAPIApiService {
  constructor(private apiService: OpenAPIService) {}

  public getFrontVersion(platformType: PlatformType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelString> {
    return this.apiService.openFrontVersion(platformType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getApiStatus(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.openGetApiHealth(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getAvailableLoads(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<LatLonModel[]> {
    return this.apiService.openGetLoads(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getTrackingByToken(token: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TrackingModel> {
    return this.apiService.openGetTracking(token, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
